import { useSelector } from 'react-redux'

const getInitialVisitorData = (appConfig: any = {}) => {
  const {
    growthBook: { attributes = {} },
    areaCode,
    country,
    storeId,
    currency,
    sessionId: mafSessionId = '',
    mafUserId = ''
  } = appConfig

  const visitorId = mafUserId || mafSessionId

  return {
    context: {
      ...attributes,
      id: visitorId,
      platform: 'web',
      areaCode,
      country,
      storeId,
      currency
    },
    anonymousId: mafUserId ? mafSessionId : '',
    id: visitorId,
    isAuthenticated: !!mafUserId
  }
}

const useFsVisitorData = () => {
  const { appConfig = {} } = useSelector((state: any) => state)
  const initialVisitorData = getInitialVisitorData(appConfig)
  return initialVisitorData
}

export default useFsVisitorData
